$(function () {
$('.burger').on('click', function () {
$('.sp_nav').fadeToggle(200);
// $('.eng_header_logo').fadeToggle(200);
$(this).toggleClass('toggle')
$('body').toggleClass('noscroll');
});

$('.sp_nav li a').on('click', function () {
$('.sp_nav').fadeOut(200);
$('.burger').toggleClass('toggle')
$('body').toggleClass('noscroll');
});
});
$(function () {
$('a[href^="#"]').click(function () {
let speed = 800;
let href = $(this).attr("href");
let target = $(href == "#" || href == "" ? 'html' : href);
let position = target.offset().top;
$("html, body").animate({ scrollTop: position }, speed, "swing");
return false;
});
});





$(function () {
$(window).scroll(function () {
$(".anim").each(function () {
var scroll = $(window).scrollTop();
var blockPosition = $(this).offset().top;
var windowHeihgt = $(window).height();
if (scroll > blockPosition - windowHeihgt + 50) {
    $(this).addClass('is-animated');
}else{
$(this).removeClass('is-animated');
}
});
});
});


$(function () {
    $('.faq_list dt').on('click', function () {
        $(this).next().slideToggle(300);
        $(this).toggleClass('active');
    });
});


//スクロールした際の動きを関数でまとめる
function PageTopAnime() {

    var scroll = $(window).scrollTop(); //スクロール値を取得
    if (scroll >= 200){//200pxスクロールしたら
      $('.float').removeClass('DownMove');   // DownMoveというクラス名を除去して
      $('.float').addClass('UpMove');      // UpMoveというクラス名を追加して出現
    }else{//それ以外は
      if($('.float').hasClass('UpMove')){//UpMoveというクラス名が既に付与されていたら
        $('.float').removeClass('UpMove'); //  UpMoveというクラス名を除去し
        $('.float').addClass('DownMove');  // DownMoveというクラス名を追加して非表示
      }
    }
    
    var wH = window.innerHeight; //画面の高さを取得
    var footerPos =  $('.eng_footer').offset().top; //footerの位置を取得
    if(scroll+wH >= (footerPos+10)) {
      var pos = (scroll+wH) - footerPos+10 //スクロールの値＋画面の高さからfooterの位置＋10pxを引いた場所を取得し
      $('.float').css('bottom',pos); //.floatに上記の値をCSSのbottomに直接指定してフッター手前で止まるようにする
    }else{//それ以外は
      if($('.float').hasClass('UpMove')){//UpMoveというクラス名がついていたら
        $('.float').css('bottom','10px');// 下から10pxの位置にページリンクを指定
      }
    }
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  PageTopAnime();/* スクロールした際の動きの関数を呼ぶ*/
});

